module.exports = __webpack_public_path__ + "img/own-goal.9772ae69.svg";